import { Box } from '@mui/system'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { UserAvatar } from './Avatar'
import React from 'react'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'
import colors from '@/styles/colors'
import { useLocalStorage } from '@/hooks/common'

export interface UserInteractionProps {
  date: string
  avatar: string
  name: string
  userID: string
}

export function UserInteraction({ date, avatar, name, userID }: UserInteractionProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [ewUser] = useLocalStorage('ewUser', null)
  const isLoggedInUser = ewUser?.user != userID

  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box py={1}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '9px' }}>
          <UserAvatar size={35} borderRadius={35} name={name} />
          <Typography variant='label'>{isLoggedInUser ? 'You' : name}</Typography>
        </Box>
        <Box display='flex' justifyContent={'space-between'} alignItems='center'>
          <Box width={40}>
            {isLoggedInUser && (
              <IconButton
                onClick={handleClick}
                id='demo-positioned-button'
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
              >
                <SVG src={SVGS.MoreIcon} color={colors.moreDotsGray} />
              </IconButton>
            )}
            <Menu
              id='options-menu'
              aria-labelledby='demo-positioned-button'
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuItem onClick={handleClose}>View Profile</MenuItem>
              {/* <MenuItem onClick={handleClose}>Connect</MenuItem> */}
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
